// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4644":"eea2f240","7697":"6bf57d9c"}[chunkId] + ".chunk.css";
};